import * as z from "zod";
import { acumaticaIntegrationSchema } from "./acumatica-integration-schema";

export const getAcumaticaIntegration = {
  name: "getAcumaticaIntegration" as const,
  input: z.object({}),
  output: acumaticaIntegrationSchema,
};
